export default __webpack_public_path__ + "static/media/circle-in-circle-cssart.e8972b05.png";